import type { ComponentType, ReactNode } from "react";
import { DashboardStatCardShell } from "@/components/sections/dashboard-stat-card-shell";
import { DashboardAreaLineChart, DashboardStatMetric } from "@/components/sections/dashboard-area-line-chart";

type DashboardTrendCardProps = {
  title: string;
  value: ReactNode;
  chartId: string;
  direction: "up" | "down";
  tone: "negative" | "positive";
  metricTone?: "negative" | "positive" | "neutral";
  metricIcon?: ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
  metricCentered?: boolean;
  className?: string;
  decorative?: boolean;
  align?: "left" | "center";
};

export function DashboardTrendCard({
  title,
  value,
  chartId,
  direction,
  tone,
  metricTone,
  metricIcon,
  metricCentered = false,
  className = "",
  decorative = false,
  align = "left",
}: DashboardTrendCardProps) {
  return (
    <DashboardStatCardShell title={title} decorative={decorative} align={align} className={className}>
      <DashboardStatMetric
        tone={metricTone ?? tone}
        icon={metricIcon}
        centered={metricCentered || align === "center"}
      >
        {value}
      </DashboardStatMetric>
      <DashboardAreaLineChart id={chartId} direction={direction} tone={tone} />
    </DashboardStatCardShell>
  );
}
